
import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import LandingPage from './landing-page'

export default function AuthRequired({ children }) {

  const { isLoading, isAuthenticated } = useAuth0();

  if (isLoading) {
    return null;
  } else if (isAuthenticated) {
    return children;
  } else {
    return <LandingPage />
  }
}
